// extracted by mini-css-extract-plugin
module.exports = {"topAdjustment":"CmsFixieHeroSection_topAdjustment__yeHvx","stickyCTA":"CmsFixieHeroSection_stickyCTA__pIDYs"};